module.exports = __webpack_public_path__ + "img/indicate_icon_3.c9e73cb1.png";